import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { BreadcrumbItemContext } from '../../provider/BreadcrumbItemContextProvider';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MetadataContentTabs } from '../../ui-parts/MetadataContentTabs';
import { utility } from '../../utility';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { MyMModal } from '../../ui-elements/MyMModal';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { useLocation } from 'react-router-dom';

/**
 * ServiceLv2 Page Component
 */
const ServiceLv2 = () => {

  const screenId = 'MyM304';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(null);
  const navigate = useNavigate();
  const queryParam = useParams();
  const { setBreadcrumbItem } = useContext(BreadcrumbItemContext);
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2025.3.5 MyMine Version2.1対応 Add Start
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const location = useLocation();
  // 2025.3.5 MyMine Version2.1対応 Add End

  useEffect(() => {
    /**
     * Contents情報取得成功時処理
     * @param {any} result
     */
    const callbackSuccessRequestServiceContents = (result) => {

      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestServiceContents();
        return;
      }

      // モバイル表示の場合、省略文字を設定
      const breadcrumbLink = isPc ? (result.ModelMetadataName ?? result.MetadataCategoryName) : utility.convertEllipsisFormat((result.ModelMetadataName ?? result.MetadataCategoryName), 14);
      // パンくずリストにMetadataNameを設定
      setBreadcrumbItem(breadcrumbLink);
      setContent(result);
      setIsLoading(false);

      // 2025.3.5 MyMine Version2.1対応 Add Start
      if (location?.state?.previewFileId) {
        setPreviewFileId(location.state.previewFileId);
        setIsModalOpen(true);
      }
      // 2025.3.5 MyMine Version2.1対応 Add End

    }

    /**
     * Contents情報取得失敗時処理
     */
    const callbackFailedRequestServiceContents = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }
    apiRequest.requestJson(`api/service/lv2?metadataId=${queryParam.metadata_id}`, 'GET', callbackSuccessRequestServiceContents, callbackFailedRequestServiceContents)

    // アンマウント時、パンくずリストのコンテキストをクリア
    return () => {
      setBreadcrumbItem(null);
    }
  }, []);

  if (content == null)
    return <MyMProgress />

  const serviceLv2Label =
    controlSettings.LabelList['lblServiceLv2Massage_' + content.MetadataCategoryId] ??
    controlSettings.LabelList['lblServiceLv2Massage_' + queryParam.metadata_id];

  const serviceLv2Image =
    controlSettings.ImageList['imgServiceLv2_' + content.MetadataCategoryId] ?
      controlSettings.ImageList['imgServiceLv2_' + content.MetadataCategoryId]
      :
      isPc ?
        controlSettings.ImageList['imgServiceLv2_' + queryParam.metadata_id] :
        controlSettings.ImageList['imgServiceLv2_' + queryParam.metadata_id + '_mobile']
    ;

  return (
    <Box className='py-1 d-flex flex-column'>
      {isLoading && <MyMProgress />}
      <Box className='mb-4'>
        <MyMVariantLabel variant='h5'>{content.ModelMetadataName ?? content.MetadataCategoryName}</MyMVariantLabel>
        <MyMLabel>{serviceLv2Label}</MyMLabel>
      </Box>
      <Grid container className='pb-2 flex-grow-1'>
        <Grid item xs={12} md={3} className='d-flex justify-content-center' sx={{ '> img': { maxWidth: '100%', maxHeight: 550 } }}>
          {serviceLv2Image && <MyMImage screenId={screenId} filePath={serviceLv2Image} />}
        </Grid>
        <Grid item xs={12} md={8.7}>
          <MetadataContentTabs
            paramMetadataId={queryParam.metadata_id}
            screenId={screenId}
            metadataContent={content}
            setIsLoading={setIsLoading}
            // 2025.3.5 MyMine Version2.1対応 Add Start
            canShareContents={true}
            contentsShareParameter={location?.state}
            isDefaultOpenFirstAccordion={true}
            // 2025.3.5 MyMine Version2.1対応 Add End
          />
        </Grid>
      </Grid>
      {/* 2025.3.5 MyMine Version2.1対応 Add Start */}
     <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
      {/* 2025.3.5 MyMine Version2.1対応 Add End */}
    </Box>
  );
}
export default ServiceLv2;
